// DENNIS: not sure if this is actually the way to go, but works okay for now.
// You can simulate this with your browsers "Responsive design mode" and setting the "custom user agent" to one of values below.
export const isMobile = (): boolean =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isPwa = (): boolean =>
    isMobile() &&
    ["mobile", "localhost"].includes(window.location.host.split(".")[0].toLowerCase()) &&
    Boolean(localStorage.getItem("mobileDomainOverride"));
